import { render, staticRenderFns } from "./member-vendor-detail.vue?vue&type=template&id=3b72622e&"
import script from "./member-vendor-detail.vue?vue&type=script&lang=js&"
export * from "./member-vendor-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports